<!--
This file is part of the project: "Digiziege"
An app for animal-welfare-oriented goat husbandry and contactless weight estimation.
GitLab: https://gitlab.rlp.net/proj-wise2526-digiziege/digiziege

Copyright (c) 2026 Digiziege Team TH-Bingen

Description:
Companion app for welfare-oriented goat husbandry featuring contactless weight estimation via camera,
master data management and health tracking.
Built as a PWA with a local-first approach to ensure data privacy.

LICENSE INFORMATION:
This program is free software: you can redistribute it and/or modify it under the terms of the
GNU Affero General Public License as published by the Free Software Foundation,
either version 3 of the License, or (at your option) any later version.

This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
See the GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License along with this program.
If not, see <https://www.gnu.org/licenses/>.
-->

<template>
  <span
    class="w-12 h-6 bg-gray-300 rounded-full relative inline-block cursor-pointer transition-colors"
    :class="modelValue ? 'bg-[var(--color-primary-300)]' : 'bg-gray-300'"
    @click="$emit('update:modelValue', !modelValue)"
  >
    <span
      class="block w-6 h-6 bg-[var(--color-primary-500)] rounded-full shadow transform transition-transform"
      :class="{ 'translate-x-6': modelValue }"
    ></span>
  </span>
</template>

<script setup>
defineProps({
  modelValue: { 
    type: Boolean, 
    required: true 
    // The current state of the toggle, passed from the parent via v-model
  }
})

defineEmits([
  'update:modelValue' 
  // Event triggered when the toggle is clicked. Vue automatically listens for this event when using v-model and updates the bound variable in the parent component
])
</script>

